export default __webpack_public_path__ + "static/media/10.dc50d65a.png";